// extracted by mini-css-extract-plugin
export default {"expandBTN":"viewerStyles_expandBTN__Iv+mS","expandBTNFather":"viewerStyles_expandBTNFather__UMiri","expandBTNFatherOd":"viewerStyles_expandBTNFatherOd__grMtn"};